<div class="reminder-dialog">
  <h2 mat-dialog-title>
    <mat-icon class="title-icon">notifications_active</mat-icon>
    Emlékeztető beállítása
  </h2>

  <div mat-dialog-content>
    <div class="quick-reminder-buttons">
      <button mat-stroked-button type="button" (click)="setQuickReminder('1hour')" class="quick-btn">
        1 óra múlva
      </button>
      <button mat-stroked-button type="button" (click)="setQuickReminder('tomorrow9')" class="quick-btn">
        Holnap 9:00
      </button>
      <button mat-stroked-button type="button" (click)="setQuickReminder('2days')" class="quick-btn">
        2 nap múlva
      </button>
      <button mat-stroked-button type="button" (click)="setQuickReminder('nextmonday')" class="quick-btn">
        Jövő hét hétfő
      </button>
    </div>

    <div class="reminder-datetime-row">
      <mat-form-field appearance="outline" class="reminder-date-field">
        <mat-label>Dátum</mat-label>
        <input matInput [matDatepicker]="reminderPicker" [(ngModel)]="reminderDate">
        <mat-datepicker-toggle matIconSuffix [for]="reminderPicker"></mat-datepicker-toggle>
        <mat-datepicker #reminderPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" class="reminder-time-field">
        <mat-label>Időpont</mat-label>
        <mat-select [(ngModel)]="selectedTime">
          @for (t of timeSlots; track t) {
            <mat-option [value]="t">{{ t }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button color="warn" (click)="onClear()">
      <mat-icon>notifications_off</mat-icon>
      Emlékeztető törlése
    </button>
    <span class="spacer"></span>
    <button mat-button (click)="onCancel()">Mégse</button>
    <button mat-flat-button color="primary" (click)="onSave()" [disabled]="!reminderDate">
      <mat-icon>check</mat-icon>
      Beállítás
    </button>
  </div>
</div>
